import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import { getCalcList } from '@/calc-system/registry/calc_registry';

export default new Vuex.Store({
	state: {
		user_info: '', //用户信息
		token: '', //登陆
		calc_list: getCalcList(), //计算器列表（从注册中心获取）
	},
	getters: {
		//获取用户信息
		getUserInfo(state) {
			return state.user_info;
		},
		//获取token
		getToken(state) {
			return state.token;
		},
		//获取地区下的计算器列表
		getAreaCalcList(state) {
			return state.calc_list;
		},
		getCalc(state){
			return state.calc_list;
		}
	},
	mutations: {
		//设置计算器
		setCalc(state,data){
			state.calc_list = data;
		},
		//设置用户信息
		serUserInfo(state, data) {
			state.user_info = data;
		},
		//设置token
		setToken(state, data) {
			state.token = data;
		},
		//设置地区下的计算器列表
		setAreaCalcList(state, data) {
			state.calc_list = data;
		}
	},
	actions: {

	},
	modules: {}
})
